module.exports = __webpack_public_path__ + "static/media/Lavender Brown 2.df0da62e.jpg";